import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';
import { CustomDataLayerEventType } from 'app/data-layers/model/data-layer-event-types';
import { DataLayerStaticData } from 'app/data-layers/static-data/data-layer-static-data';
import { DataLayerUtils } from 'app/data-layers/utils/data-layer-utils';

export const pushErrorEvent = (
    isLoggedIn: boolean,
    dataLayerErrorType: DataLayerErrorType,
    partnerId: string | undefined,
    productName?: string,
) =>
    DataLayerUtils.pushErrorEventToDataLayer({
        event: CustomDataLayerEventType.ECOM_ERROR,
        error_message: dataLayerErrorType,
        error_product: productName || '',
        partner_id: partnerId,
        error_area: DataLayerStaticData.ERROR_AREA,
        business_unit: DataLayerStaticData.BUSINESS_UNIT,
        logged_in: isLoggedIn,
    });
